import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/exercise-details.png'


const _withScopeId = n => (_pushScopeId("data-v-2fe1f622"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "modalExerciseDetails",
  class: "modal fade",
  tabindex: "-1",
  role: "dialog",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document",
  style: {"max-width":"700px"}
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "position-absolute top-0 end-0 mt-2 me-2 z-index-1" }
const _hoisted_5 = { class: "position-absolute top-50 start-0 translate-middle-y z-index-1" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-caret-left fa-2x" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "position-absolute top-50 end-0 translate-middle-y z-index-1" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-caret-right fa-2x" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "modal-body px-5 py-4" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, "5/145, Message, Male, US English", -1))
const _hoisted_16 = { class: "col text-end me-4" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_18 = { class: "row align-items-center mb-3" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { controls: "" }
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Your browser does not support the audio element. ")
const _hoisted_23 = { class: "col ms-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "exercise-rating"
}, " Teacher's Rating: ", -1))
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-3\" data-v-2fe1f622><div class=\"col\" data-v-2fe1f622><img class=\"bd-placeholder-img\" src=\"" + _imports_0 + "\" width=\"320\" height=\"200\" alt=\"...\" data-v-2fe1f622></div><div class=\"col\" data-v-2fe1f622><div class=\"form-floating\" data-v-2fe1f622><textarea class=\"form-control\" id=\"exercise-note\" placeholder=\"Note for Student(s)\" style=\"height:200px;max-height:200px;\" data-v-2fe1f622></textarea><label for=\"exercise-note\" data-v-2fe1f622>Note for Student(s)</label></div></div></div><div class=\"row\" data-v-2fe1f622><div class=\"col\" data-v-2fe1f622><ul class=\"fs-sm--1\" data-v-2fe1f622><li data-v-2fe1f622> When I visited it for the first time, I knew that we should buy it. </li><li data-v-2fe1f622>I knew your Mom would really like the kitchen.</li><li data-v-2fe1f622> I like having a big bedroom with the window looking at the gardes. </li><li data-v-2fe1f622>I also knew that it was a house we could grow into.</li><li data-v-2fe1f622>When we bought the house, it only gad two bedrooms.</li><li data-v-2fe1f622> But, as we had more children, I was able to rennovate other rooms for each of you. </li><li data-v-2fe1f622>The only thing I didn&#39;t like were the stairs.</li><li data-v-2fe1f622> The stairs were very noisy when someone went up or down. </li><li data-v-2fe1f622>(entire text)</li></ul></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Rating = _resolveComponent("Rating")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn-close btn btn-sm btn-circle d-flex flex-center transition-base",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-warning btn-sm",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('prev'))),
            disabled: _ctx.first
          }, _hoisted_8, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-warning btn-sm",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('next'))),
            disabled: _ctx.last
          }, _hoisted_12, 8, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              (_ctx.added == false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-falcon-primary me-1 mb-1 btn-table-header",
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)))
                  }, " Choose + "))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-falcon-primary me-1 mb-1 btn-table-header",
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
                  }, " Remove - "))
            ])
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("audio", _hoisted_20, [
                (_ctx.content && _ctx.content.questionsAudio)
                  ? (_openBlock(), _createElementBlock("source", {
                      key: 0,
                      src: _ctx.content.questionsAudio.url,
                      type: "audio/mpeg"
                    }, null, 8, _hoisted_21))
                  : _createCommentVNode("", true),
                _hoisted_22
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_Rating, {
                id: "exercise-rating",
                value: 3,
                "max-value": 5
              })
            ])
          ]),
          _hoisted_25
        ])
      ])
    ])
  ], 512))
}